import React, {useContext} from "react";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {MessageContext} from "../../../Message.tsx";
import {getProviderField} from "../../../../../MenuPanel/UserProfileDropdown/UserProfileDropdown";
import {formatTimestamp} from "../../../../../../Utils/misc/dateUtils.ts";

interface UserAvatarProps {
    timestamp: number;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ timestamp }) => {
    const { isPreview } = useContext(MessageContext);
    const userIcon = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images//defaultProfilePic.svg";

    const userObj = useAppStore((state: any) => state.userObj);
    const getUserAvatar = () => {
        if (!isPreview && userObj.user) {
            return getProviderField(userObj.user, 'photoURL') || userIcon;
        }
        return userIcon;
    };

    const formattedTimestamp = formatTimestamp(timestamp);
    const userAvatar = getUserAvatar();

    return (
        <div
            data-tooltip-id="main-tooltip"
            data-tooltip-content={formattedTimestamp}
            data-tooltip-place={"top"}
        >
            <img
                src={userAvatar}
                alt="User Avatar"
                className="w-7 h-7 rounded-full shadow shadow-black object-cover object-center"
            />
        </div>
    )
}

export default UserAvatar;